import { CpaShopDto, CpaShopModel } from '../../data-layer/cpa/types';

export const toCpaShopsModel = (dto: CpaShopDto[]): CpaShopModel[] =>
    dto.map((item) => ({
        name: item.shop_name,
        description: item.shop_description,
        icon: item.overall_icon,
        url: item.url,
        badges: item.badges_info?.map((badge) => ({ type: badge.badge_type, text: badge.text })),
    }));
